import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Branch } from 'src/app/services/branch/branch.model';

import { FurnitureCreditService } from 'src/app/services/furniture-credit/furniture-credit.service';

@Component({
  selector: 'app-furniture-confirmation',
  templateUrl: './furniture-confirmation.component.html',
  styleUrls: ['./furniture-confirmation.component.scss'],
})
export class FurnitureConfirmationComponent implements OnInit {
  branch: Branch | null = null;

  constructor(
    private creditService: FurnitureCreditService,
    private router: Router,
    private titleService: Title
  ) {
    this.titleService.setTitle('Sims Furniture | Confirmation');

    const extras = this.router.getCurrentNavigation()?.extras;

    if (extras) {
      this.branch = extras.state?.['branch'] ?? null;
    }
  }

  ngOnInit(): void {}

  onExitApplication() {
    this.creditService.clearApplication();
    this.router.navigateByUrl('/furniture/applicant', { replaceUrl: true });
  }
}
